import Moment from "moment"
export const yearsToNow = () => {
  const years = []
  const dateStart = Moment([2019])
  const dateEnd = Moment().dayOfYear(0)
  while (dateEnd.diff(dateStart, "years") >= 0) {
    years.push(dateStart.format("YYYY"))
    dateStart.add(1, "year")
  }
  return years.reverse()
}